import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2016ec00&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016ec00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2016ec00')) {
      api.createRecord('2016ec00', component.options)
    } else {
      api.reload('2016ec00', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=2016ec00&scoped=true&", function () {
      api.rerender('2016ec00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M8rXvHs5V9e8/JS/comp/Accordion.vue"
export default component.exports